import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { mb, mt, pb, px, py } from '@lendi-ui/spacing';
import { select } from '@lendi-ui/theme';
import { body } from '@lendi-ui/typography';

import { materialCard } from '../_common/style';

export const TempCard = styled.div`
  ${mb('md')}
  ${materialCard};
`;

export const TempCardHeader = styled.div`
  border-top-left-radius: ${select('borderRadius')};
  border-top-right-radius: ${select('borderRadius')};
  background-color: ${() => getColour('fill', 'contrast')};
  position: relative;
  ${body({ size: 'md' })}
  ${py('xxs')}
  ${px('sm')}
`;

export const TempCardHeaderText = styled.div`
  color: ${() => getColour('fill', 'main')};
`;

export const TempCardContent = styled.div`
  ${pb('md')}

  /* Gives a margin top to all its children except the first */
    & > * {
    ${mt('md')} :first-child {
      ${mt('nil')}
    }
  }
`;
